module.exports = __webpack_public_path__ + "img/选刊logo.3243a108.png";